/* import App, React */

import './App.css';
import './WishHandle.js';

//import image for empty cell
import emptyCell from './img/cell_Img/00-Empty.png';

/* import { openModal } from './WishEffects/Wish9Effects'; */
import { Wish1Effect,Wish2Effect,Wish3Effect,Wish4Effect,Wish5Effect,Wish6Effect,Wish7Effect,Wish8Effect,
          Wish9Effect,Wish10Effect, Wish11Effect, Wish12Effect, Wish13Effect, Wish14Effect, Wish15Effect
  }from './WishEffects/WishEffects';




 
/* const checkID = function(){
    const Ids = document.querySelectorAll(".image");
     console.table(Ids[0].id);
  } */


                                        /*//////////////// WISHES ////////////////*/                        
    const Wishes = function(){
        const cells = document.querySelectorAll(".image");

        const cell_1 = cells[0];
        const cell_2 = cells[1];
        const cell_3 = cells[2];
        const cell_4 = cells[3];
        const cell_5 = cells[4];
        const cell_6 = cells[5];
        const cell_7 = cells[6];
        const cell_8 = cells[7];
        const cell_9 = cells[8];

        const cell_10 = cells[9];
        const cell_11 = cells[10];
        const cell_12 = cells[11];
        const cell_13 = cells[12];
        const cell_14 = cells[13];
        const cell_15 = cells[14];
        const cell_16 = cells[15];
        const cell_17 = cells[16];
        const cell_18 = cells[17];
        const cell_19 = cells[18];
        const cell_20 = cells[19];

          /* WISH 1 - Code: 1-1-14-14-14
                            1-1-0-14-14
                            6-6-0-4-4
                            6-6-10-4-4                   */
          let wish1 = cell_1.id === "1" && cell_2.id === "1" && cell_3.id === "14" && cell_4.id === "14" && cell_5.id === "14" &&
                      cell_6.id === "1" && cell_7.id === "1" && cell_8.id === "0" && cell_9.id === "14" && cell_10.id === "14" &&
                      cell_11.id === "6" && cell_12.id === "6" && cell_13.id === "0" && cell_14.id === "4" && cell_15.id === "4" &&
                      cell_16.id === "6" && cell_17.id === "6" && cell_18.id === "10" && cell_19.id === "4" && cell_20.id === "4";

           /* WISH 2 - Code:  4-0-11-0-3
                              4-0-11-0-3
                              2-0-10-0-3
                              2-0-10-0-5            */
          let wish2 = cell_1.id === "4" && cell_2.id === "0" && cell_3.id === "11" && cell_4.id === "0" && cell_5.id === "3" &&
                      cell_6.id === "4" && cell_7.id === "0" && cell_8.id === "11" && cell_9.id === "0" && cell_10.id === "3" &&
                      cell_11.id === "2" && cell_12.id === "0" && cell_13.id === "10" && cell_14.id === "0" && cell_15.id === "3" &&
                      cell_16.id === "2" && cell_17.id === "0" && cell_18.id === "10" && cell_19.id === "0" && cell_20.id === "5";

          /* WISH 3 - Code:   1-0-1-0-1
                              0-5-0-5-0
                              9-0-9-0-9
                              0-13-0-13-0                   */
          let wish3 = cell_1.id === "1" && cell_2.id === "0" && cell_3.id === "1" && cell_4.id === "0" && cell_5.id === "1" &&
                      cell_6.id === "0" && cell_7.id === "5" && cell_8.id === "0" && cell_9.id === "5" && cell_10.id === "0" &&
                      cell_11.id === "9" && cell_12.id === "0" && cell_13.id === "9" && cell_14.id === "0" && cell_15.id === "9" &&
                      cell_16.id === "0" && cell_17.id === "13" && cell_18.id === "0" && cell_19.id === "13" && cell_20.id === "0";

          /* WISH 4 - Code:   15-16-16-16-13
                              7-15-8-13-7
                              7-13-0-15-7
                              13-6-6-6-15                   */
          let wish4 = cell_1.id === "15" && cell_2.id === "16" && cell_3.id === "16" && cell_4.id === "16" && cell_5.id === "13" &&
                      cell_6.id === "7" && cell_7.id === "15" && cell_8.id === "8" && cell_9.id === "13" && cell_10.id === "7" &&
                      cell_11.id === "7" && cell_12.id === "13" && cell_13.id === "0" && cell_14.id === "15" && cell_15.id === "7" &&
                      cell_16.id === "13" && cell_17.id === "6" && cell_18.id === "6" && cell_19.id === "6" && cell_20.id === "15";


        /* WISH 5 - Code:   5-12-15-12-5
                            0-9-16-9-0
                            0-9-15-9-0
                            5-12-15-12-5                   */
        let wish5 = cell_1.id === "5" && cell_2.id === "12" && cell_3.id === "15" && cell_4.id === "12" && cell_5.id === "5" &&
                    cell_6.id === "0" && cell_7.id === "9" && cell_8.id === "16" && cell_9.id === "9" && cell_10.id === "0" &&
                    cell_11.id === "0" && cell_12.id === "9" && cell_13.id === "15" && cell_14.id === "9" && cell_15.id === "0" &&
                    cell_16.id === "5" && cell_17.id === "12" && cell_18.id === "15" && cell_19.id === "12" && cell_20.id === "5";

        /* WISH 6 - Code:   10-13-16-13-10
                            1-10-0-10-1
                            1-0-0-0-1
                            11-11-11-11-11                   */
        let wish6 = cell_1.id === "10" && cell_2.id === "13" && cell_3.id === "16" && cell_4.id === "13" && cell_5.id === "10" &&
                    cell_6.id === "1" && cell_7.id === "10" && cell_8.id === "0" && cell_9.id === "10" && cell_10.id === "1" &&
                    cell_11.id === "1" && cell_12.id === "0" && cell_13.id === "0" && cell_14.id === "0" && cell_15.id === "1" &&
                    cell_16.id === "11" && cell_17.id === "11" && cell_18.id === "11" && cell_19.id === "11" && cell_20.id === "11";
        
        /* WISH 7 - Code:   16-4-12-0-6
                            9-0-0-7-15
                            9-0-14-7-15
                            16-4-12-0-6                   */
        let wish7 = cell_1.id === "16" && cell_2.id === "4" && cell_3.id === "12" && cell_4.id === "0" && cell_5.id === "6" &&
                    cell_6.id === "9" && cell_7.id === "0" && cell_8.id === "0" && cell_9.id === "7" && cell_10.id === "15" &&
                    cell_11.id === "9" && cell_12.id === "0" && cell_13.id === "14" && cell_14.id === "7" && cell_15.id === "15" &&
                    cell_16.id === "16" && cell_17.id === "4" && cell_18.id === "12" && cell_19.id === "0" && cell_20.id === "6";

        /* WISH 8 - Code:   0-12-14-11-0
                            0-12-14-11-0
                            0-12-16-11-0
                            0-12-14-11-0                   */
        let wish8 = cell_1.id === "0" && cell_2.id === "12" && cell_3.id === "14" && cell_4.id === "11" && cell_5.id === "0" &&
                    cell_6.id === "0" && cell_7.id === "12" && cell_8.id === "14" && cell_9.id === "11" && cell_10.id === "0" &&
                    cell_11.id === "0" && cell_12.id === "12" && cell_13.id === "16" && cell_14.id === "11" && cell_15.id === "0" &&
                    cell_16.id === "0" && cell_17.id === "12" && cell_18.id === "14" && cell_19.id === "11" && cell_20.id === "0";



            /* WISH 9 - Code: 0-0-0-0-0
                              0-2-2-2-0
                              0-2-2-14-0
                              0-0-0-0-0   */
            let wish9 = cell_1.id === "0" && cell_2.id === "0" && cell_3.id === "0" && cell_4.id === "0" && cell_5.id === "0" &&
                        cell_6.id === "0" && cell_7.id === "2" && cell_8.id === "2" && cell_9.id === "2" && cell_10.id === "0" &&
                        cell_11.id === "0" && cell_12.id === "2" && cell_13.id === "2" && cell_14.id === "14" && cell_15.id === "0" &&
                        cell_16.id === "0" && cell_17.id === "0" && cell_18.id === "0" && cell_19.id === "0" && cell_20.id === "0";

            /* WISH 10 - Code: 2-2-0-0-2
                                2-12-12-0-4
                                2-0-7-7-4
                                0-0-0-4-4                   */
            let wish10 = cell_1.id === "2" && cell_2.id === "2" && cell_3.id === "0" && cell_4.id === "0" && cell_5.id === "2" &&
                        cell_6.id === "2" && cell_7.id === "12" && cell_8.id === "12" && cell_9.id === "0" && cell_10.id === "4" &&
                        cell_11.id === "2" && cell_12.id === "0" && cell_13.id === "7" && cell_14.id === "7" && cell_15.id === "4" &&
                        cell_16.id === "0" && cell_17.id === "0" && cell_18.id === "0" && cell_19.id === "4" && cell_20.id === "4";

             /* WISH 11 - Code: 15-15-0-16-16
                                15-0-2-5-16
                                9-0-2-0-6
                                9-9-0-6-6                   */
            let wish11 = cell_1.id === "15" && cell_2.id === "15" && cell_3.id === "0" && cell_4.id === "16" && cell_5.id === "16" &&
                        cell_6.id === "15" && cell_7.id === "0" && cell_8.id === "2" && cell_9.id === "5" && cell_10.id === "16" &&
                        cell_11.id === "9" && cell_12.id === "0" && cell_13.id === "2" && cell_14.id === "0" && cell_15.id === "6" &&
                        cell_16.id === "9" && cell_17.id === "9" && cell_18.id === "0" && cell_19.id === "6" && cell_20.id === "6";

            /* WISH 12 - Code:  1-0-0-0-9
                                1-1-9-9-9
                                4-4-12-15-15
                                4-0-0-0-15                   */
            let wish12 = cell_1.id === "1" && cell_2.id === "0" && cell_3.id === "0" && cell_4.id === "0" && cell_5.id === "9" &&
                        cell_6.id === "1" && cell_7.id === "1" && cell_8.id === "9" && cell_9.id === "9" && cell_10.id === "9" &&
                        cell_11.id === "4" && cell_12.id === "4" && cell_13.id === "12" && cell_14.id === "15" && cell_15.id === "15" &&
                        cell_16.id === "4" && cell_17.id === "0" && cell_18.id === "0" && cell_19.id === "0" && cell_20.id === "15";

            /* WISH 13 - Code:  13-2-14-15-8
                                13-2-0-15-8
                                8-15-0-2-13
                                8-15-0-2-13                   */
            let wish13 = cell_1.id === "13" && cell_2.id === "2" && cell_3.id === "14" && cell_4.id === "15" && cell_5.id === "8" &&
                        cell_6.id === "13" && cell_7.id === "2" && cell_8.id === "0" && cell_9.id === "15" && cell_10.id === "8" &&
                        cell_11.id === "8" && cell_12.id === "15" && cell_13.id === "0" && cell_14.id === "2" && cell_15.id === "13" &&
                        cell_16.id === "8" && cell_17.id === "15" && cell_18.id === "0" && cell_19.id === "2" && cell_20.id === "13";

            /* WISH 14 - Code:  5-10-14-9-5
                                0-0-16-0-0
                                1-0-6-8-0
                                5-12-0-0-11                   */
            let wish14 = cell_1.id === "5" && cell_2.id === "10" && cell_3.id === "14" && cell_4.id === "9" && cell_5.id === "5" &&
                        cell_6.id === "0" && cell_7.id === "0" && cell_8.id === "16" && cell_9.id === "0" && cell_10.id === "0" &&
                        cell_11.id === "1" && cell_12.id === "0" && cell_13.id === "6" && cell_14.id === "8" && cell_15.id === "0" &&
                        cell_16.id === "5" && cell_17.id === "12" && cell_18.id === "0" && cell_19.id === "0" && cell_20.id === "11";

          /* WISH 15 - Code:  16-15-00-09-10
                              16-15-08-09-10
                              00-15-03-09-00
                              00-00-13-00-00                   */
          let wish15 = cell_1.id === "16" && cell_2.id === "15" && cell_3.id === "0" && cell_4.id === "9" && cell_5.id === "10" &&
                      cell_6.id === "16" && cell_7.id === "15" && cell_8.id === "8" && cell_9.id === "9" && cell_10.id === "10" &&
                      cell_11.id === "0" && cell_12.id === "15" && cell_13.id === "3" && cell_14.id === "9" && cell_15.id === "0" &&
                      cell_16.id === "0" && cell_17.id === "0" && cell_18.id === "13" && cell_19.id === "0" && cell_20.id === "0";

           
                        
           switch (true) {

              /* Wish 01 */
               case wish1:

                wish1Granted();  

                break;
                
              /* Wish02 */
                case wish2:
                
                  wish2Granted(); 
                                
                break;

              /* Wish03 */
                case wish3:

                  wish3Granted(); 
                                
                        break;
                
              /* Wish04 */
                case wish4:

                  wish4Granted(); 
                              
                      break;
                    
               /* Wish05 */
                  case wish5:
                  
                  wish5Granted(); 
                              
                      break;
                
                /* Wish06 */
                  case wish6:

                    wish6Granted(); 
                                
                        break;
                
                /* Wish07 */
                  case wish7:

                    wish7Granted(); 
                                
                        break;

                /* Wish08 */
                  case wish8:

                    wish8Granted(); 
                                
                        break;


                 /* WISH 09 */

                  case wish9:

                    wish9Granted();
                   
                      break;

                /* Wish10 */
                  case wish10:
  
                    wish10Granted(); 
                                
                        break;
                
                /* Wish11 */                                    
                case wish11:

                  wish11Granted(); 
                              
                      break;

                /* Wish12 */
                case wish12:

                  wish12Granted(); 
                              
                      break;
                
                /* Wish13 */
                case wish13:

                  wish13Granted(); 
                              
                      break;

                /* Wish14 */
                case wish14:

                  wish14Granted(); 
                              
                      break;               
                                       
                /* Wish 15 */
                case wish15:

                wish15Granted();

                break;
                
            
              default:                   
                    console.log("no wish granted");
                    resetWall();
                    break;               
            };

            function wish1Granted(){
              console.log("Wish 1 granted");
              Wish1Effect();
              resetWall();
            }

            function wish2Granted(){
              console.log("Wish 2 granted");
              Wish2Effect();
              resetWall();
            }

            function wish3Granted(){
              console.log("Wish 3 granted");
              Wish3Effect();
              resetWall();
            }

            function wish4Granted(){
              console.log("Wish 4 granted");
              Wish4Effect();
              resetWall();
            }

            function wish5Granted(){
              console.log("Wish 5 granted");
              Wish5Effect();
              resetWall();
            }

            function wish6Granted(){
              console.log("Wish 6 granted");
              Wish6Effect();
              resetWall();
            }

            function wish7Granted(){
              console.log("Wish 7 granted");
              Wish7Effect();
              resetWall();
            }

            function wish8Granted(){
              console.log("Wish 8 granted");
              Wish8Effect();
              resetWall();
            }

            function wish9Granted(){
              console.log("Wish 9 granted");
             /* open Failsafe modal, play Failsafe */
             Wish9Effect();               
              resetWall();
            }

            function wish10Granted(){
              console.log("Wish 10 granted");
              Wish10Effect();
              resetWall();
            }

            function wish11Granted(){
              console.log("Wish 11 granted");
              Wish11Effect();
              resetWall();
            }

            function wish12Granted(){
              console.log("Wish 12 granted");
              Wish12Effect();
              resetWall();
            }

            function wish13Granted(){
              console.log("Wish 13 granted");
              Wish13Effect();
              resetWall();
            }

            function wish14Granted(){
              console.log("Wish 14 granted");
              Wish14Effect();
              resetWall();
            }

            function wish15Granted(){
              console.log("Wish 15 granted");
              Wish15Effect();
              resetWall();
            }

            
            /* use at the end of every Wish && default inside switch case */

            function resetWall(){

              /* resetting ids of changed ids/cells to 0 && change image to default image*/
              for (let item of cells) {
                  if(item.id !=="0"){
                    item.id = "0";
                    item.src=emptyCell;                    
                  }             
              }            
            }            
    }
  
export default Wishes;